function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var InavigateRight = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20266 12.7864L16.3727 12.7864L11.4927 17.6664C11.1027 18.0564 11.1027 18.6964 11.4927 19.0864C11.8827 19.4764 12.5127 19.4764 12.9027 19.0864L19.4927 12.4964C19.8827 12.1064 19.8827 11.4764 19.4927 11.0864L12.9027 4.49641C12.5127 4.10641 11.8827 4.10641 11.4927 4.49641C11.1027 4.88641 11.1027 5.51641 11.4927 5.90641L16.3727 10.7864L5.20266 10.7864C4.65265 10.7864 4.20266 11.2364 4.20266 11.7864C4.20266 12.3364 4.65266 12.7864 5.20266 12.7864Z",
    fill: "#495057"
  }));
});